/**
 * This function is meant to be used for input type="datetime-local" only.
 * @description This function converts a Date to a datetime-local compatible string.
 * @link https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/datetime-local
 */
const convertDateToDateTimeLocalString = (date: Date): string => {
  // source: https://dev.to/kevinluo201/set-value-of-datetime-local-input-field-3435
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');

  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

export default convertDateToDateTimeLocalString;
